import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';

const Benefit: React.FC<{ icon: React.ReactNode, text: React.ReactNode }> = ({ icon, text }) => (
  <Box display="flex" alignItems="flex-start" gap={1}>
    {icon}
    <Typography fontSize="1.4rem" fontWeight={400}>
      {text}
    </Typography>
  </Box>
);

export default Benefit;
